











import Vue from 'vue'

export default Vue.extend({
  name: "UiButton",
  props: {
    disabled: Boolean,
    color: String,
    loading: Boolean,
    icon: Boolean,
    click: Function
  }
})
